// ============================================
// Directive: bmDragRow
// ============================================
angular.module('bizmetryApp').directive('bmDragRow', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var el = element[0];
            var currentIndex = null;

            attrs.$observe('bmDragIndex', function (val) {
                currentIndex = parseInt(val, 10);
                el.draggable = true;
            });

            el.addEventListener('dragstart', function (e) {
                if (currentIndex === null) return;
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/plain', String(currentIndex));
                setTimeout(function () {
                    scope.$apply(function () { scope.onDragStart(currentIndex); });
                }, 0);
            });

            el.addEventListener('dragover', function (e) {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
                if (currentIndex === null) return;
                var rect = el.getBoundingClientRect();
                var above = e.clientY < (rect.top + rect.height / 2);
                scope.$apply(function () { scope.onDragOver(currentIndex, above); });
            });

            el.addEventListener('dragleave', function (e) {
                if (!el.contains(e.relatedTarget)) {
                    scope.$apply(function () { scope.onDragLeave(currentIndex); });
                }
            });

            el.addEventListener('drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (currentIndex === null) return;
                scope.$apply(function () { scope.onDrop(currentIndex); });
            });

            el.addEventListener('dragend', function () {
                scope.$apply(function () { scope.onDragEnd(); });
            });
        }
    };
});


// ============================================
// Controller: EditFrameDialogController
// ============================================
angular.module('bizmetryApp').controller('EditFrameDialogController', function (
    $scope, $mdDialog, $mdToast, $mdPanel, $timeout, frame, template, dialogService
) {

    // ============================================
    // Inicialización
    // ============================================
    $scope.frame = angular.copy(frame);
    $scope.components = $scope.frame.frame_fields || [];
    $scope.selectedComponentIndex = null;
    $scope.pendingDeleteComponents = {};
    $scope.isDirty = false;
    $scope.template = template;

    console.log('$scope.template=>', $scope.template);
    console.log('$scope.frame=>', $scope.frame);

    $scope.frameEdit = {
        frame_name: $scope.frame.frame_name,
        frame_description: $scope.frame.frame_description
    };

    // ============================================
    // Snapshot helpers
    // ============================================
    function _sortKeys(value) {
        if (Array.isArray(value)) {
            return value.map(_sortKeys);
        }
        if (value !== null && typeof value === 'object') {
            return Object.keys(value).sort().reduce(function (acc, k) {
                acc[k] = _sortKeys(value[k]);
                return acc;
            }, {});
        }
        return value;
    }

    function _serialize() {
        return angular.toJson(_sortKeys({
            frame_name: $scope.frameEdit.frame_name,
            frame_description: $scope.frameEdit.frame_description,
            components: $scope.components
        }));
    }

    $scope.components.forEach(function (component) {
        (component.nested_table_columns || []).forEach(function (col) {
            col.column_type = col.column_type || 'SCALAR';
        });
    });
    var _snapshot = _serialize();

    // ============================================
    // Component Type & Scalar Type Options
    // ============================================
    // OBJECT_FIELD_REF: the value of one attribute of an imported object. The biz event maps the
    // object's id (like an OBJECT_REFERENCE); at runtime the resource is looked up by that id and
    // the attribute's value is what lands in the frame.
    $scope.componentTypes = [
        { value: 'CUSTOM', label: 'Custom', icon: 'tune' },
        { value: 'FIELD_REFERENCE', label: 'Field Reference', icon: 'link' },
        { value: 'OBJECT_REFERENCE', label: 'Object Reference', icon: 'account_tree' },
        { value: 'OBJECT_FIELD_REF', label: 'Object Field Reference', icon: 'subdirectory_arrow_right' },
        { value: 'NESTED_TABLE', label: 'Nested Table', icon: 'table_chart' }
    ];

    $scope.getComponentTypeOption = function (value) {
        return $scope.componentTypes.find(function (ct) { return ct.value === value; }) || null;
    };

    // Types whose component points at one attribute of a resource type (resource + attribute)
    function _isAttributeRef(type) {
        return type === 'FIELD_REFERENCE' || type === 'OBJECT_FIELD_REF';
    }
    $scope.isAttributeRef = function (component) {
        return _isAttributeRef(component.frame_component_type);
    };

    // Nested-table column types. SCALAR keeps its stored value (existing templates); it's the
    // "SCALAR REF" of the UI. SCALAR_INLINE defines its own data type, like a CUSTOM field.
    // OBJECT_FIELD_REF is the column form of the OBJECT_FIELD_REF field: mapped from the object's
    // id, it holds one attribute of the imported object.
    $scope.nestedColumnTypes = [
        { value: 'SCALAR', label: 'SCALAR REF' },
        { value: 'OBJECT_REF', label: 'OBJECT REF' },
        { value: 'OBJECT_FIELD_REF', label: 'OBJECT FIELD REF' },
        { value: 'SCALAR_INLINE', label: 'SCALAR INLINE' }
    ];

    // Columns that find their object by id need a resource type with a PK
    $scope.nestedColUsesPkResources = function (col) {
        return col.column_type === 'OBJECT_REF' || col.column_type === 'OBJECT_FIELD_REF';
    };
    // Columns that point at one attribute of the resource type
    $scope.nestedColHasAttribute = function (col) {
        return col.column_type === 'SCALAR' || col.column_type === 'OBJECT_FIELD_REF';
    };

    $scope.scalarTypes = [
        { value: 'STRING', label: 'String' },
        { value: 'INTEGER', label: 'Integer' },
        { value: 'FLOAT', label: 'Float' },
        { value: 'BOOLEAN', label: 'Boolean' },
        { value: 'DATE', label: 'Date' },
        { value: 'TIMESTAMP', label: 'Timestamp' },
        { value: 'ENUM', label: 'Enum' }
    ];

    // ============================================
    // Type Dropdown State
    // ============================================
    $scope.typeDropdownOpenId = null;
    $scope.typeDropdownAbove = {};
    $scope.typeDropdownStyles = {};

    $scope.isComponentSensitiveLocked = function (component) {
        if (!_isAttributeRef(component.frame_component_type)) return false;
        if (!component.attribute_type_id) return false;
        var attrTypes = ($scope.template && $scope.template.templateConfig &&
            $scope.template.templateConfig.attribute_types) || [];
        var source = attrTypes.find(function (a) {
            return a.id === component.attribute_type_id;
        });
        return source ? source.isSensitive === true : false;
    };

    $scope.toggleSensitive = function (component, $event) {
        $event.stopPropagation();
        if ($scope.isComponentSensitiveLocked(component)) return;
        component.is_sensitive = !component.is_sensitive;
        $scope.markDirty();
    };

    $scope.toggleTypeDropdown = function (componentId, $event) {
        if ($scope.typeDropdownOpenId === componentId) {
            $scope.typeDropdownOpenId = null;
            return;
        }

        $scope.typeDropdownOpenId = componentId;
        var trigger = $event.currentTarget;

        $timeout(function () {
            var rect = trigger.getBoundingClientRect();
            var dropdownHeight = 180;
            var viewportHeight = window.innerHeight;
            var spaceBelow = viewportHeight - rect.bottom;
            var openAbove = spaceBelow < dropdownHeight + 8;
            $scope.typeDropdownAbove[componentId] = openAbove;
            // ya no se necesita typeDropdownStyles
        }, 0);
    };

    $scope.selectComponentType = function (component, newType) {
        if (component.frame_component_type === newType) {
            $scope.typeDropdownOpenId = null;
            return;
        }

        component.frame_component_type = newType;

        var customFields = [
            'scalar_attribute_type',
            'lower_bound', 'upper_bound',
            'max_length', 'regex_pattern',
            'enum_values'
        ];
        var referenceFields = [
            'resource_type_id', 'resource_type_name',
            'attribute_type_id', 'attribute_type_name'
        ];
        var nestedFields = ['nested_table_columns'];

        if (newType === 'CUSTOM') {
            referenceFields.forEach(function (f) { delete component[f]; });
            nestedFields.forEach(function (f) { delete component[f]; });
            component.scalar_attribute_type = null;
            component.lower_bound = null;
            component.upper_bound = null;
            component.max_length = null;
            component.regex_pattern = null;
            component.enum_values = [];

        } else if (newType === 'OBJECT_REFERENCE') {
            customFields.forEach(function (f) { delete component[f]; });
            delete component.attribute_type_id;
            delete component.attribute_type_name;
            nestedFields.forEach(function (f) { delete component[f]; });

        } else if (newType === 'FIELD_REFERENCE') {
            customFields.forEach(function (f) { delete component[f]; });
            nestedFields.forEach(function (f) { delete component[f]; });

        } else if (newType === 'OBJECT_FIELD_REF') {
            customFields.forEach(function (f) { delete component[f]; });
            nestedFields.forEach(function (f) { delete component[f]; });
            // The object is looked up by its id: only resource types with a PK qualify
            if (component.resource_type_id &&
                !$scope.resourcesWithPK.some(function (rt) { return rt.id === component.resource_type_id; })) {
                referenceFields.forEach(function (f) { delete component[f]; });
            }

        } else if (newType === 'NESTED_TABLE') {
            customFields.forEach(function (f) { delete component[f]; });
            referenceFields.forEach(function (f) { delete component[f]; });
            if (!component.nested_table_columns) {
                component.nested_table_columns = [];
            }
        }

        $scope.markDirty();
        $scope.typeDropdownOpenId = null;
    };

    // ── Cerrar dropdown al hacer click fuera ──
    var _closeDropdown = function (e) {
        if ($scope.typeDropdownOpenId !== null) {
            var target = e.target || e.srcElement;
            var inside = false;
            var el = target;
            while (el) {
                if (el.classList && el.classList.contains('type-cell')) { inside = true; break; }
                el = el.parentElement;
            }
            if (!inside) {
                $scope.$apply(function () { $scope.typeDropdownOpenId = null; });
            }
        }
    };

    document.addEventListener('click', _closeDropdown);

    // ── Cerrar dropdown al hacer scroll en el content del dialog ──
    var _contentEl = document.querySelector('.edit-frame-dialog .frame-content');
    var _closeDropdownOnScroll = function () {
        if ($scope.typeDropdownOpenId) {
            $scope.$apply(function () { $scope.typeDropdownOpenId = null; });
        }
    };

    if (_contentEl) {
        _contentEl.addEventListener('scroll', _closeDropdownOnScroll);
    }

    // ── Cleanup al destruir el scope ──
    $scope.$on('$destroy', function () {
        document.removeEventListener('click', _closeDropdown);
        if (_contentEl) {
            _contentEl.removeEventListener('scroll', _closeDropdownOnScroll);
        }
    });

    // ============================================
    // Scalar Type Changes
    // ============================================
    $scope.onScalarTypeChange = function (component) {
        component.lower_bound = null;
        component.upper_bound = null;
        component.max_length = null;
        component.regex_pattern = null;
        component.enum_values = [];

        if (component.scalar_attribute_type === 'STRING') {
            component.max_length = 64;
            component.regex_pattern = '.*';
        }

        $scope.markDirty();
    };

    // ============================================
    // Resources with PK (for OBJECT_REFERENCE selector)
    // ============================================
    $scope.resourcesWithPK = (function () {
        var resourceTypes = (
            $scope.template &&
            $scope.template.templateConfig &&
            $scope.template.templateConfig.resource_types
        ) || [];
        var attributeTypes = (
            $scope.template &&
            $scope.template.templateConfig &&
            $scope.template.templateConfig.attribute_types
        ) || [];

        var pkResourceIds = {};
        attributeTypes.forEach(function (attr) {
            if (attr.isPrimaryKey === true) {
                pkResourceIds[attr.resource_id] = true;
            }
        });

        return resourceTypes
            .filter(function (rt) { return !!pkResourceIds[rt.id]; })
            .sort(function (a, b) {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
    })();

    $scope.resourcesForFieldRef = (function () {
        var resourceTypes = ($scope.template?.templateConfig?.resource_types) || [];
        var attributeTypes = ($scope.template?.templateConfig?.attribute_types) || [];

        var resourcesWithAttrs = {};
        attributeTypes.forEach(function (at) {
            if (at.resource_id) resourcesWithAttrs[at.resource_id] = true;
        });

        return resourceTypes
            .filter(function (rt) { return !!resourcesWithAttrs[rt.id]; })
            .sort(function (a, b) {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
    })();

    $scope.getAttributesForResource = function (resourceTypeId) {
        if (!resourceTypeId) return [];
        var attributeTypes = ($scope.template?.templateConfig?.attribute_types) || [];
        return attributeTypes
            .filter(function (at) { return at.resource_id === resourceTypeId; })
            .sort(function (a, b) {
                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
    };

    // ── FIELD_REFERENCE / OBJECT_FIELD_REF handlers ──

    // An OBJECT_FIELD_REF finds its object by id, so it needs a resource type with a PK
    $scope.getAttributeRefResources = function (component) {
        return component.frame_component_type === 'OBJECT_FIELD_REF'
            ? $scope.resourcesWithPK : $scope.resourcesForFieldRef;
    };

    $scope.onFieldRefResourceChange = function (component) {
        delete component.attribute_type_id;
        delete component.attribute_type_name;
        var found = ($scope.template?.templateConfig?.resource_types || [])
            .find(function (rt) { return rt.id === component.resource_type_id; });
        component.resource_type_name = found ? found.name : null;
        $scope.markDirty();
    };

    $scope.onFieldRefAttributeChange = function (component) {
        var attrs = $scope.getAttributesForResource(component.resource_type_id);
        var found = attrs.find(function (at) { return at.id === component.attribute_type_id; });
        component.attribute_type_name = found ? found.name : null;
        // Auto-marcar sensitive si el atributo referenciado lo es
        if (found && found.isSensitive === true) {
            component.is_sensitive = true;
        }
        $scope.markDirty();
    };

    $scope.onFieldRefClear = function (component) {
        delete component.resource_type_id;
        delete component.resource_type_name;
        delete component.attribute_type_id;
        delete component.attribute_type_name;
        $scope.markDirty();
    };

    // ── OBJECT_REFERENCE handler ──

    $scope.onObjectReferenceChange = function (component) {
        var found = ($scope.template?.templateConfig?.resource_types || [])
            .find(function (rt) { return rt.id === component.resource_type_id; });
        component.resource_type_name = found ? found.name : null;
        $scope.markDirty();
    };

    // ============================================
    // NESTED_TABLE column management
    // ============================================

    $scope.addNestedColumn = function (component) {
        if (!component.nested_table_columns) {
            component.nested_table_columns = [];
        }
        component.nested_table_columns.push({
            column_name: '',
            column_type: 'SCALAR',
            resource_type_id: null,
            resource_type_name: null,
            attribute_type_id: null,
            attribute_type_name: null
        });
        $scope.markDirty();
    };

    $scope.removeNestedColumn = function (component, index) {
        if (!component.nested_table_columns) return;
        component.nested_table_columns.splice(index, 1);
        $scope.markDirty();
    };

    var INLINE_SPEC_FIELDS = ['column_description', 'scalar_attribute_type', 'lower_bound', 'upper_bound',
        'max_length', 'regex_pattern', 'enum_values'];

    $scope.onNestedColTypeChange = function (component, col) {
        col.attribute_type_id = null;
        col.attribute_type_name = null;
        col.attribute_type_desc = null;
        if (col.column_type === 'SCALAR_INLINE') {
            // No resource / attribute: the column defines its own description, type and parameters.
            col.resource_type_id = null;
            col.resource_type_name = null;
            col.resource_type_desc = null;
            col.column_description = col.column_description || '';
            col.scalar_attribute_type = null;
            $scope.onScalarTypeChange(col);
            return;
        }
        INLINE_SPEC_FIELDS.forEach(function (f) { delete col[f]; });
        var resources = $scope.nestedColUsesPkResources(col) ? $scope.resourcesWithPK : $scope.resourcesForFieldRef;
        if (!resources.some(function (rt) { return rt.id === col.resource_type_id; })) {
            col.resource_type_id = null;
            col.resource_type_name = null;
        }
        $scope.markDirty();
    };

    $scope.onNestedColResourceChange = function (component, col) {
        col.attribute_type_id = null;
        col.attribute_type_name = null;
        var found = ($scope.template?.templateConfig?.resource_types || [])
            .find(function (rt) { return rt.id === col.resource_type_id; });
        col.resource_type_name = found ? found.name : null;
        $scope.markDirty();
    };

    $scope.onNestedColAttributeChange = function (component, col) {
        var attrs = $scope.getAttributesForResource(col.resource_type_id);
        var found = attrs.find(function (at) { return at.id === col.attribute_type_id; });
        col.attribute_type_name = found ? found.name : null;
        $scope.markDirty();
    };

    $scope.isNestedColumnIncomplete = function (col) {
        if (!col.column_name || col.column_name.trim() === '') return true;
        if (col.column_type === 'SCALAR_INLINE') {
            return !col.column_description || col.column_description.trim() === '' ||
                !$scope.isScalarSpecValid(col);
        }
        return !col.resource_type_id ||
            (col.column_type !== 'OBJECT_REF' && !col.attribute_type_id);
    };

    // Key of a nested column's enum chip input (columns have no id of their own).
    $scope.nestedColKey = function (component, index) {
        return component.frame_component_id + '-col-' + index;
    };

    $scope.nestedColumnIncompleteMessage = function (col) {
        switch (col.column_type) {
            case 'OBJECT_REF':    return 'Complete name and resource';
            case 'SCALAR_INLINE': return 'Complete name, description, data type and its parameters';
            default:              return 'Complete name, resource and attribute';
        }
    };

    // ============================================
    // ENUM Chips
    // ============================================
    $scope.enumInputs = {};

    // inputKey identifies the chip input: the component id for a CUSTOM field, a per-column key
    // for a SCALAR_INLINE nested-table column.
    $scope.onEnumKeydown = function ($event, component, inputKey) {
        var key = inputKey || component.frame_component_id;
        var SPACE = 32;
        var ENTER = 13;
        var BACKSPACE = 8;
        var key = $event.keyCode || $event.which;

        if (key === SPACE || key === ENTER) {
            $event.preventDefault();
            var raw = $scope.enumInputs[key] || '';
            var val = raw.trim();
            if (val) {
                if (!component.enum_values) component.enum_values = [];
                if (component.enum_values.indexOf(val) === -1) {
                    component.enum_values.push(val);
                    $scope.markDirty();
                }
                $scope.enumInputs[key] = '';
            }
        } else if (key === BACKSPACE) {
            var current = $scope.enumInputs[key] || '';
            if (!current && component.enum_values && component.enum_values.length > 0) {
                component.enum_values.splice(component.enum_values.length - 1, 1);
                $scope.markDirty();
            }
        }
    };

    $scope.removeEnumValue = function (component, index) {
        component.enum_values.splice(index, 1);
        $scope.markDirty();
    };

    $scope.focusEnumInput = function (componentId) {
        var input = document.getElementById('enum-input-' + componentId);
        if (input) input.focus();
    };

    // ============================================
    // Dirty Detection
    // ============================================
    $scope.markDirty = function () {
        $scope.isDirty = (_serialize() !== _snapshot);
    };

    $scope._checkDirty = function () {
        $scope.isDirty = (_serialize() !== _snapshot);
    };

    $scope.$watch(function () {
        return _serialize();
    }, function (newVal) {
        $scope.isDirty = (newVal !== _snapshot);
    });

    // ============================================
    // Sort Components
    // ============================================
    $scope.sortComponents = function () {
        if (!$scope.components || $scope.components.length === 0) {
            $scope.sortedComponents = [];
            return;
        }
        $scope.sortedComponents = $scope.components.slice().sort(function (a, b) {
            return (a.frame_field_seq || 0) - (b.frame_field_seq || 0);
        });
    };

    $scope.sortComponents();

    // ============================================
    // Selection
    // ============================================
    $scope.selectComponent = function (index) {
        $scope.selectedComponentIndex = index;
        $scope.typeDropdownOpenId = null;
    };

    // ============================================
    // Stats
    // ============================================
    $scope.getComponentCountByType = function (type) {
        if (!$scope.sortedComponents) return 0;
        return $scope.sortedComponents.filter(function (c) {
            return c.frame_component_type === type;
        }).length;
    };

    // ============================================
    // Drag & Drop
    // ============================================
    $scope.drag = {
        active: false,
        sourceIndex: null,
        targetIndex: null,
        insertBefore: true
    };

    $scope.onDragStart = function (index) {
        $scope.drag.active = true;
        $scope.drag.sourceIndex = index;
        $scope.drag.targetIndex = null;
        $scope.typeDropdownOpenId = null;
    };

    $scope.onDragOver = function (index, above) {
        if (!$scope.drag.active) return;
        $scope.drag.targetIndex = index;
        $scope.drag.insertBefore = above;
    };

    $scope.onDragLeave = function (index) {
        if ($scope.drag.targetIndex === index) $scope.drag.targetIndex = null;
    };

    $scope.onDrop = function (targetIndex) {
        var sourceIndex = $scope.drag.sourceIndex;
        if (sourceIndex === null || sourceIndex === targetIndex) {
            $scope._resetDrag();
            return;
        }

        var movedComp = $scope.sortedComponents[sourceIndex];
        var targetComp = $scope.sortedComponents[targetIndex];

        var actualSourceIdx = $scope.components.indexOf(movedComp);
        var actualTargetIdx = $scope.components.indexOf(targetComp);

        var insertAt = $scope.drag.insertBefore ? actualTargetIdx : actualTargetIdx + 1;

        $scope.components.splice(actualSourceIdx, 1);
        if (actualSourceIdx < insertAt) insertAt--;
        $scope.components.splice(insertAt, 0, movedComp);

        $scope.components.forEach(function (comp, i) {
            comp.frame_field_seq = i + 1;
        });

        $scope.sortComponents();
        $scope._checkDirty();
        $scope._resetDrag();

        $mdToast.show(
            $mdToast.simple()
                .textContent('Component reordered: ' + movedComp.frame_field_name)
                .position('top right')
                .hideDelay(1800)
        );
    };

    $scope.onDragEnd = function () { $scope._resetDrag(); };

    $scope._resetDrag = function () {
        $scope.drag.active = false;
        $scope.drag.sourceIndex = null;
        $scope.drag.targetIndex = null;
        $scope.drag.insertBefore = true;
    };

    // ============================================
    // Delete in Two Stages
    // ============================================
    $scope.confirmOrDeleteComponent = function (component, index) {
        var componentId = component.frame_component_id;

        if ($scope.pendingDeleteComponents[componentId]) {
            var actualIndex = $scope.components.indexOf(component);
            if (actualIndex === -1) actualIndex = index;

            var deletedSeq = component.frame_field_seq;
            $scope.components.splice(actualIndex, 1);

            $scope.components.forEach(function (comp) {
                if (comp.frame_field_seq > deletedSeq) comp.frame_field_seq--;
            });

            $scope.sortComponents();
            $scope.frame.frame_fields = $scope.components;
            delete $scope.pendingDeleteComponents[componentId];
            $scope._checkDirty();
            $scope.$applyAsync();

            $mdToast.show(
                $mdToast.simple()
                    .textContent('Component deleted: ' + component.frame_field_name)
                    .position('top right')
                    .hideDelay(2000)
            );

            if ($scope.components.length === 0) {
                $scope.selectedComponentIndex = null;
            } else if (index >= $scope.components.length) {
                $scope.selectedComponentIndex = $scope.components.length - 1;
            } else {
                $scope.selectedComponentIndex = index;
            }

        } else {
            $scope.pendingDeleteComponents[componentId] = true;
            $timeout(function () {
                delete $scope.pendingDeleteComponents[componentId];
            }, 4000);
        }
    };

    // ============================================
    // View Nested Columns Panel (read-only, kept for compatibility)
    // ============================================
    $scope.viewNestedColumns = function (component, $event) {
        if ($event) $event.stopPropagation();

        if (!component.nested_table_columns || component.nested_table_columns.length === 0) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('No columns configured for this nested table')
                    .position('top right')
                    .hideDelay(2000)
            );
            return;
        }

        var position = $mdPanel.newPanelPosition().absolute().center();

        $mdPanel.open({
            attachTo: angular.element(document.body),
            controller: 'NestedColumnsPanelController',
            controllerAs: 'ctrl',
            template: `
            <div class="nested-columns-panel">
                <div class="nested-panel-header">
                    <div class="nested-panel-header-content">
                        <div class="nested-panel-title-section">
                            <md-icon class="nested-panel-icon">table_chart</md-icon>
                            <div class="nested-panel-title-text">
                                <h2>Nested Table Columns</h2>
                                <div class="nested-panel-subtitle">{{ ctrl.componentName }}</div>
                            </div>
                        </div>
                        <md-button class="md-icon-button nested-panel-close" ng-click="ctrl.close()">
                            <md-icon style="color:white;">close</md-icon>
                        </md-button>
                    </div>
                </div>
                <div class="nested-panel-info-badge">
                    <div class="nested-panel-info-content">
                        <md-icon class="nested-panel-info-icon">info</md-icon>
                        <span class="nested-panel-info-text">
                            <strong>{{ ctrl.columns.length }}</strong>
                            column{{ ctrl.columns.length !== 1 ? 's' : '' }} configured
                        </span>
                    </div>
                </div>
                <div class="nested-panel-table-container">
                    <table class="nested-columns-table">
                        <thead>
                            <tr>
                                <th class="col-index">#</th>
                                <th class="col-name">Column Name</th>
                                <th class="col-resource">Resource Type</th>
                                <th class="col-attribute">Attribute</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="column in ctrl.columns track by $index">
                                <td class="cell-index">{{ $index + 1 }}</td>
                                <td><div class="nested-column-name"><md-icon>label</md-icon><span>{{ column.column_name }}</span></div></td>
                                <td><div class="nested-column-resource"><md-icon>category</md-icon><span>{{ column.column_type === 'SCALAR_INLINE' ? 'Inline' : column.resource_type_name }}</span></div></td>
                                <td><div class="nested-column-attribute"><md-icon>settings</md-icon><span>{{ column.column_type === 'SCALAR_INLINE' ? column.scalar_attribute_type : column.attribute_type_name }}</span></div></td>
                            </tr>
                        </tbody>
                    </table>
                    <div ng-if="ctrl.columns.length === 0" class="nested-panel-empty">
                        <md-icon>view_column</md-icon><p>No columns configured</p>
                    </div>
                </div>
                <div class="nested-panel-footer">
                    <md-button ng-click="ctrl.close()" class="md-raised md-primary">Close</md-button>
                </div>
            </div>`,
            position: position,
            locals: { component: component },
            clickOutsideToClose: true,
            escapeToClose: true,
            focusOnOpen: true,
            zIndex: 100
        });
    };

    // ============================================
    // Add Component
    // ============================================
    $scope.addComponent = function () {
        var maxSeq = 0;
        ($scope.components || []).forEach(function (comp) {
            if ((comp.frame_field_seq || 0) > maxSeq) maxSeq = comp.frame_field_seq;
        });

        var newComponent = {
            frame_component_id: _generateUUID(),
            frame_field_name: '',
            frame_field_desc: '',
            frame_field_seq: maxSeq + 1,
            frame_component_type: 'CUSTOM',
            scalar_attribute_type: null,
            lower_bound: null,
            upper_bound: null,
            max_length: null,
            regex_pattern: null,
            enum_values: [],
            is_sensitive: false,   // ← NEW
            is_required: false     // ← NEW
        };

        $scope.components.push(newComponent);
        $scope.sortComponents();
        $scope.markDirty();
        $scope.selectedComponentIndex = $scope.sortedComponents.length - 1;

        $timeout(function () {
            $scope.editingField[newComponent.frame_component_id + '_name'] = true;
            var input = document.getElementById('input-name-' + newComponent.frame_component_id);
            if (input) input.focus();

            var content = document.querySelector('.frame-content');
            if (content) content.scrollTop = content.scrollHeight;
        }, 80);
    };

    // ============================================
    // Save
    // ============================================
    $scope.save = function () {
        if (!$scope.isDirty) return;
        $scope.frame.frame_name = $scope.frameEdit.frame_name;
        $scope.frame.frame_description = $scope.frameEdit.frame_description;
        $scope.frame.frame_fields = $scope.components;
        $mdDialog.hide($scope.frame);
    };

    // ============================================
    // Close without saving
    // ============================================
    var discardConfirmationOpen = false;
    $scope.onDialogKeydown = function (event) {
        if ((event.key === 'Escape' || event.keyCode === 27) && !event.defaultPrevented) {
            event.preventDefault();
            event.stopPropagation();
            $scope.close();
        }
    };
    $scope.close = function () {
        if (discardConfirmationOpen) { return; }
        $scope.markDirty();
        if ($scope.isDirty) {
            discardConfirmationOpen = true;
            return dialogService.showDecisionDialog(
                'Discard Changes?',
                'You have unsaved changes. Are you sure you want to discard them?'
            ).then(function (decision) {
                if (decision === 'proceed') $mdDialog.cancel();
            }).finally(function () { discardConfirmationOpen = false; });
        }
        $mdDialog.cancel();
    };

    // ============================================
    // Form validation
    // ============================================

    $scope.isFormValid = function () {
        if (!$scope.components) return true;

        return $scope.components.every(function (comp) {
            if (comp.frame_component_type !== 'CUSTOM') return true;
            return $scope.isScalarSpecValid(comp);
        });
    };

    // Data type + parameters of a CUSTOM component or a SCALAR_INLINE nested-table column
    // (same fields on both).
    $scope.isScalarSpecValid = function (spec) {
        if (!spec.scalar_attribute_type) return false;

        switch (spec.scalar_attribute_type) {

            case 'INTEGER':
            case 'FLOAT': {
                var hasMin = spec.lower_bound !== null &&
                    spec.lower_bound !== undefined &&
                    spec.lower_bound !== '';
                var hasMax = spec.upper_bound !== null &&
                    spec.upper_bound !== undefined &&
                    spec.upper_bound !== '';
                if (!hasMin || !hasMax) return false;
                var numMin = Number(spec.lower_bound);
                var numMax = Number(spec.upper_bound);
                return !isNaN(numMin) && !isNaN(numMax) && numMin < numMax;
            }

            case 'STRING': {
                var validLength = spec.max_length !== null &&
                    spec.max_length !== undefined &&
                    spec.max_length !== '' &&
                    Number(spec.max_length) > 0;
                var rawRegex = spec.regex_pattern;
                var validRegex = false;
                if (rawRegex !== null && rawRegex !== undefined && rawRegex.trim() !== '') {
                    try { new RegExp(rawRegex); validRegex = true; }
                    catch (e) { validRegex = false; }
                }
                return validLength && validRegex;
            }

            case 'ENUM':
                return !!(spec.enum_values && spec.enum_values.length > 0);

            default:
                return true;
        }
    };

    $scope.hasIncompleteFieldRef = function () {
        return ($scope.components || []).some(function (comp) {
            return _isAttributeRef(comp.frame_component_type)
                && (!comp.resource_type_id || !comp.attribute_type_id);
        });
    };

    $scope.hasIncompleteNestedTable = function () {
        return ($scope.components || []).some(function (comp) {
            if (comp.frame_component_type !== 'NESTED_TABLE') return false;
            if (!comp.nested_table_columns || comp.nested_table_columns.length === 0) return false;
            return comp.nested_table_columns.some(function (col) {
                return $scope.isNestedColumnIncomplete(col);
            });
        });
    };

    $scope.hasIncompleteObjectReference = function () {
        return ($scope.components || []).some(function (comp) {
            return comp.frame_component_type === 'OBJECT_REFERENCE'
                && !comp.resource_type_id;
        });
    };

    // ============================================
    // Validación por campo individual (CUSTOM)
    // ============================================
    $scope.isFieldInvalid = function (component, field) {
        if (component.frame_component_type !== 'CUSTOM') return false;
        return $scope.isScalarFieldInvalid(component, field);
    };

    // Per-field check of a CUSTOM component or a SCALAR_INLINE nested-table column.
    $scope.isScalarFieldInvalid = function (component, field) {
        if (!component.scalar_attribute_type) return false;

        switch (field) {

            case 'lower_bound': {
                if (component.scalar_attribute_type !== 'INTEGER' &&
                    component.scalar_attribute_type !== 'FLOAT') return false;
                var empty = component.lower_bound === null ||
                    component.lower_bound === undefined ||
                    component.lower_bound === '';
                if (empty) return true;
                var num = Number(component.lower_bound);
                if (isNaN(num)) return true;
                var numMax = Number(component.upper_bound);
                return !isNaN(numMax) && num >= numMax;
            }

            case 'upper_bound': {
                if (component.scalar_attribute_type !== 'INTEGER' &&
                    component.scalar_attribute_type !== 'FLOAT') return false;
                var empty = component.upper_bound === null ||
                    component.upper_bound === undefined ||
                    component.upper_bound === '';
                if (empty) return true;
                var num = Number(component.upper_bound);
                if (isNaN(num)) return true;
                var numMin = Number(component.lower_bound);
                return !isNaN(numMin) && num <= numMin;
            }

            case 'max_length': {
                if (component.scalar_attribute_type !== 'STRING') return false;
                var empty = component.max_length === null ||
                    component.max_length === undefined ||
                    component.max_length === '';
                if (empty) return true;
                return Number(component.max_length) <= 0;
            }

            case 'regex_pattern': {
                if (component.scalar_attribute_type !== 'STRING') return false;
                var raw = component.regex_pattern;
                if (!raw || raw.trim() === '') return true;
                try { new RegExp(raw); return false; }
                catch (e) { return true; }
            }

            case 'enum_values': {
                if (component.scalar_attribute_type !== 'ENUM') return false;
                return !component.enum_values || component.enum_values.length === 0;
            }

            default:
                return false;
        }
    };

    $scope.hasEmptyComponentFields = function () {
        return ($scope.components || []).some(function (comp) {
            return !comp.frame_field_name || comp.frame_field_name.trim() === '' ||
                !comp.frame_field_desc || comp.frame_field_desc.trim() === '';
        });
    };

    $scope.editingField = {};

    $scope.startEditing = function (componentId, field) {
        var key = componentId + '_' + field;
        $scope.editingField[key] = true;
        $timeout(function () {
            var input = document.getElementById('input-' + field + '-' + componentId);
            if (input) input.focus();
        }, 50);
    };

    $scope.stopEditing = function (componentId, field) {
        var key = componentId + '_' + field;
        $scope.editingField[key] = false;
    };

    $scope.onComponentNameChange = function (component) {
        if (component.frame_field_name) {
            component.frame_field_name = component.frame_field_name
                .toUpperCase()
                .replace(/ /g, '_')
                .trim();
        }
        $scope.markDirty();
    };

    $scope.isComponentNameDuplicated = function (component) {
        if (!component.frame_field_name || component.frame_field_name.trim() === '') return false;
        var name = component.frame_field_name.trim().toUpperCase();
        return ($scope.components || []).some(function (c) {
            return c !== component &&
                c.frame_field_name &&
                c.frame_field_name.trim().toUpperCase() === name;
        });
    };

    $scope.hasDuplicateComponentNames = function () {
        return ($scope.components || []).some(function (c) {
            return $scope.isComponentNameDuplicated(c);
        });
    };

});

function _generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });

}

// ============================================
// Controller: NestedColumnsPanelController
// ============================================
angular.module('bizmetryApp').controller('NestedColumnsPanelController', function (
    mdPanelRef, component
) {
    var ctrl = this;
    ctrl.componentName = component.frame_field_name;
    ctrl.columns = component.nested_table_columns || [];
    ctrl.close = function () { mdPanelRef && mdPanelRef.close(); };
});